// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

// CRA/Webpack: use REACT_APP_* (and allow a window fallback for static hosting)
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  (typeof window !== "undefined" &&
    window.__ENV &&
    window.__ENV.SUPABASE_URL);

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  (typeof window !== "undefined" &&
    window.__ENV &&
    window.__ENV.SUPABASE_ANON_KEY);

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Missing Supabase envs. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env.local " +
      "or define window.__ENV.SUPABASE_URL / SUPABASE_ANON_KEY in public/index.html."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // set to false if you never use OAuth/magic-link redirects
  },
  global: {
    headers: {
      "x-client-info": "playset-web",
    },
  },
});
